import clsx from 'clsx';
import Logo from 'core/modules/atoms/Logo/Logo';
import AddLicenseForm from 'core/modules/components/forms/AddLicenseForm';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';

const SignUpStepLicense = ({
  t,
  onChangeDisabledButton,
  changeTextButton,
  onDeleteLicense,
  hasMoreLicenses,
  loadMoreLicenses,
  licenses,
  onCheckLicense,
  cleanLicenses,
  layoutRight,
  step,
}) => {
  useEffect(() => {
    changeTextButton(t('actions:Continue'));
    onChangeDisabledButton(true);
    cleanLicenses();
  }, []);

  function onSubmit(data) {
    onCheckLicense(data);
  }

  return (
    <div className="signup-step-license">
      <div className="signup__step">
        <div className="signup__column1">
          <div className="signup__step-content">
            <div className="signup__logo">
              <Logo size="big" />
            </div>
            <div className="signup__header">
              <span className="signup__titlepart1">
                {t('Registrations')}&nbsp;<span className="signup__titlepart2">{t('Licenses')}</span>{' '}
              </span>
            </div>
            <span className="signup__description">{t('Add your licenses to continue')}</span>
            <div className="signup-step-license__form">
              <AddLicenseForm onSubmit={onSubmit} />
            </div>
          </div>
        </div>

        <div className="signup__column2">{layoutRight || <div className={clsx('signup__image', `signup__image--step${step}`)}></div>}</div>
      </div>
    </div>
  );
};

SignUpStepLicense.propTypes = {
  onDeleteLicense: PropTypes.func,
  licenses: PropTypes.array,
  onCheckLicense: PropTypes.func,
  step: PropTypes.number,
};

SignUpStepLicense.defaultProps = {
  onDeleteLicense: function () {},
  onCheckLicense: function () {},
  licenses: [],
  step: 0,
};

export default withTranslation(['signup', 'actions', 'placeholder'])(SignUpStepLicense);
